import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { api } from "@/lib/api";

const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-US", { month: "short", year: "2-digit" });

export const SatisfactionTrend = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/satisfaction-trend").then((r) => setData(r.data.map((m) => ({ ...m, label: monthLabel(m.month) })))).catch(() => setData([])); }, []);
  if (!data) return null;
  const total = data.reduce((a, m) => a + m.count, 0);
  const avg = total ? (data.reduce((a, m) => a + (m.average || 0) * m.count, 0) / total).toFixed(2) : null;
  const axis = { stroke: "#64748b", fontSize: 11, fontFamily: "JetBrains Mono" };
  return (
    <section className="mt-6 rounded-xl border border-slate-800 bg-slate-900/70 p-6" data-testid="satisfaction-trend">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div><h2 className="flex items-center gap-2 font-display text-lg font-semibold"><Star className="h-5 w-5 text-amber-400" />Client satisfaction</h2>
          <p className="text-xs text-slate-500">Monthly average rating (1–5) and number of ratings, last 12 months</p></div>
        <p className="text-sm text-slate-400"><span data-testid="satisfaction-avg" className="num text-2xl font-bold text-amber-400">{avg ?? "–"}</span> avg · <span className="num">{total}</span> ratings</p>
      </div>
      {total === 0 ? <p className="text-sm text-slate-500" data-testid="satisfaction-empty">No ratings in the last 12 months yet.</p> : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data}>
              <CartesianGrid stroke="#1e293b" vertical={false} />
              <XAxis dataKey="label" {...axis} />
              <YAxis yAxisId="r" domain={[0, 5]} ticks={[1, 2, 3, 4, 5]} {...axis} width={30} />
              <YAxis yAxisId="c" orientation="right" allowDecimals={false} {...axis} width={30} />
              <Tooltip contentStyle={{ background: "#0f172a", border: "1px solid #334155", borderRadius: 8 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar yAxisId="c" dataKey="count" name="Ratings" fill="#334155" radius={[4, 4, 0, 0]} />
              <Line yAxisId="r" dataKey="average" name="Avg rating" stroke="#fbbf24" strokeWidth={2.5} connectNulls dot={{ r: 3 }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
};
